module.exports = __webpack_public_path__ + "static/media/faboutImgCard2.04e3af4b.png";